import axios from 'axios';

  const BackendAPI = axios.create({
    // baseURL: 'http://localhost:8080/portal',
    
     baseURL: 'https://asaaua.epramaan.gov.in/asaauaportal', //for prod
   // baseURL: 'http://10.210.5.24:8080',  //for local machine
   // baseURL: 'https://asaauak.epramaan.in/asaauaportal'  //stagging
  });

  export { BackendAPI };